import { useEffect, useState } from "react";

const SLIDES = [
  { src: "/projects/smm-hamburg/smm-hamburg-1.webp", cap: "SMM Hamburg 2026 · KEXUN · SmartGen · GCE" },
  { src: "/projects/usa/kyb.webp", cap: "AAPEX Las Vegas 2025 · KYB" },
  { src: "/projects/portfolio/salone-del-mobile-2026-milano-italy-7-exhibition-stand-stagehook.webp", cap: "Salone del Mobile 2026 · Milan" },
  { src: "/projects/russia/glassco-1.webp", cap: "Analitika Expo Moscow 2026 · Glassco" },
];

export const HeroSlides = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="hero-slides" className="absolute inset-0 lg:left-auto lg:w-[52%]" aria-hidden="true">
      {SLIDES.map((s, k) => (
        <img key={s.src} src={s.src} alt="" fetchPriority={k === 0 ? "high" : undefined} loading={k === 0 ? "eager" : "lazy"} decoding="async"
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000" style={{ opacity: k === i ? 1 : 0 }} />
      ))}
      <div className="absolute inset-0 lg:hidden" style={{ background: "rgba(7,7,10,0.78)" }} />
      <div className="absolute inset-0 hidden lg:block" style={{ background: "linear-gradient(90deg, var(--bg) 0%, rgba(7,7,10,0.55) 35%, rgba(7,7,10,0.15) 100%)" }} />
      <div className="absolute inset-x-0 bottom-0 h-40" style={{ background: "linear-gradient(0deg, var(--bg) 0%, transparent 100%)" }} />
      <div data-testid="hero-slide-caption" className="hidden lg:block absolute bottom-10 right-10 font-mono text-[10px] tracking-[0.2em] text-[var(--text-soft)] uppercase">{SLIDES[i].cap}</div>
    </div>
  );
};

export default HeroSlides;
